import script from "./TableItemCount.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableItemCount.vue?vue&type=script&setup=true&lang=ts"

import "./TableItemCount.vue?vue&type=style&index=0&id=0123d32e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0123d32e"]])

export default __exports__